import React from 'react';
import Alert from 'reactstrap/lib/Alert';

interface DuoErrorProps {
	errorMessage?: string;
}

/**
 * Basic component to display an error message for when an error occurs when trying to do 2FA authentication with Duo
 */
export default function DuoError(props?: DuoErrorProps) {
	return (
		<Alert color="warning">
			<strong>
				An error occurred when trying to log you in using Duo.
				<p />
				{props?.errorMessage ? (
					<>
						{props.errorMessage}
						<p />
					</>
				) : null}
			</strong>
			<a href="/login">Click here to try again.</a>
		</Alert>
	);
}

/**
 * Component to display the error message that Duo is unavailable.
 */
export const DuoOffline = () => <DuoError errorMessage="Duo is currently unavailable." />;
